import * as svg from "../../../assets/stripe-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const StripeIcon = iconBuilder(svg, "StripeIcon", "0 0 16 16");
